angular.module('lf.common')

.directive('bazaarVoiceHandler', function (scrolls) {
  return function (scope, el, attrs) {
    var $reviewsSummaryContainer = $('#BVRRSecondarySummaryContainer');
    var $reviewsContainer = $('#BVRRContainerExp');
    var $buttons = el.find('.bazaar-voice__buttons');
    var $buttonsInSummary = $buttons.eq(0);
    var $buttonsBottom = $buttons.eq(1);
    var $btnShowMore = $buttonsInSummary.find('.bazaar-voice__btn-show-more');
    var $btnShowLess = $buttonsInSummary.find('.bazaar-voice__btn-show-less');
   
    var isMobileUI = lf.data.xhr.client.mobileUI;
    var isDesktopUI = !isMobileUI;
    var isReadyIntervalId;
    
    if (isMobileUI) {
      el
        .on('click', '.bazaar-voice__btn-show-more', function () {
          $reviewsContainer.removeClass('hide');
          $btnShowMore.addClass('hide');
          $btnShowLess.removeClass('hide');
          $buttonsBottom.removeClass('hide');
        })
        .on('click', '.bazaar-voice__btn-show-less', function () {
          $reviewsContainer.addClass('hide');
          $btnShowMore.removeClass('hide');
          $btnShowLess.addClass('hide');
          $buttonsBottom.addClass('hide');
        })
        .on('click', '.BVRRPageLink', function (e) {
          setTimeout(function () {
            scrolls.get('main').scrollToElement('#BVRRContainerExp', 500, null, -50);
          }, 100);
        });
    }
    
    function onReady () {
      var noReviews = $reviewsSummaryContainer.find('.BVRRRatingSummaryNoReviews').length;
      if (isMobileUI && noReviews) {
        // If there is no reviews hide show more/less buttons container
        $buttons.hide();
        return;
      }
      if (isDesktopUI) {
        if (noReviews) {
          $('.bazaarvoice-reviews__content').hide();
        } else {
          // Amplifi legacy
          $('#bvSum').contents().find(".BVDILink ").click(function () {
            Amplifi.BV.resizeIframe($("#bvSum")[0]);
          });
        }
      }
    }
    
    function checkIsReady () {
      var isReady = $reviewsSummaryContainer.children().length;
      if (isReady) {
        clearInterval(isReadyIntervalId);
        onReady();
      }
    }
    
    checkIsReady();

    isReadyIntervalId = setInterval(checkIsReady, 3000);
  }
});
